import React from 'react';
import { toast } from 'react-toastify';

const SignaturePrompt = ({ onSign, onSkip, showSkip = true, guestName, amount, onClose }) => {
  const handleSkip = () => {
    toast.info('You can add your signature later from your booking details', {
      position: 'top-center',
      autoClose: 3000,
    });
    onSkip();
  };

  const handleSign = () => {
    toast.info('Please draw your signature in the box below', {
      position: 'top-center',
      autoClose: 3000,
    });
    onSign();
  };

  return (
    <div className="bg-white rounded-xl shadow-2xl max-w-md w-full overflow-hidden">
      {/* Header with black gradient */}
      <div className="bg-gradient-to-r from-gray-800 to-black px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="bg-white bg-opacity-20 rounded-full p-2">
              <svg
                className="w-6 h-6 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 9h6m-6 3h6m-6 3h6M3 9h6m-6 3h6m-6 3h6m-3 3V3m0 0L4.5 6M9 3L6 6"
                />
              </svg>
            </div>
            <div>
              <h2 className="text-xl font-bold text-white">Digital Signature</h2>
              <p className="text-gray-300 text-sm">Authorization Required</p>
            </div>
          </div>
          {/* Close button */}
          <button
            onClick={onClose}
            className="text-white hover:text-gray-300 transition-colors"
            aria-label="Close"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>

      {/* Body */}
      <div className="p-6">
        {/* Guest Info */}
        <div className="bg-gray-50 rounded-lg p-3 mb-4 border border-gray-200">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-xs text-gray-500 uppercase tracking-wide">Guest</p>
              <p className="font-semibold text-gray-900">{guestName || 'Guest'}</p>
            </div>
            <div className="w-px h-8 bg-gray-200"></div>
            <div>
              <p className="text-xs text-gray-500 uppercase tracking-wide">Amount</p>
              <p className="font-semibold text-gray-900">{amount || '₹0.00'}</p>
            </div>
          </div>
        </div>

        {/* Question */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Would you like to add your digital signature to the invoice?
          </h3>
          <p className="text-gray-600 text-sm mb-3">
            This provides an official record of your approval and will be attached to your invoice.
          </p>
        </div>

        {/* Buttons */}
        <div className="flex gap-3">
          <button
            onClick={handleSign}
            className="flex-1 px-4 py-3 bg-black text-white rounded-xl hover:bg-gray-800 transition-all font-semibold shadow-md"
          >
            Add Signature
          </button>

          {showSkip && (
            <button
              onClick={handleSkip}
              className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transition-all font-medium border border-gray-200"
            >
              Skip for Now
            </button>
          )}
        </div>

        <p className="text-xs text-gray-400 text-center mt-4">
          By adding your signature, you agree to the terms and conditions
        </p>
      </div>
    </div>
  );
};

export default SignaturePrompt;
